import { CalendarEventEntity } from '../store/schema/CalendarEventEntity';
import { getAllCalendarEvents } from '../selectors/eventsCacheSelectors';
import { getAllLockedDateRanges } from '../selectors/eventsCacheSelectors';
import { getCalendarEventsOverlappingDateRanges } from '../utils/getCalendarEventsOverlappingDateRanges';
import { orchestrator } from 'satcheljs';
import {
    upsertCalendarEventsToEventsCache,
    addCalendarEventsWithinCurrentLockedDateRanges,
    calendarEventsInEventsCacheReloaded,
    removeCalendarEventWithInstanceKeyFromEventsCache,
    removeCalendarEventsFromEventsCacheMatchingFilter,
    internalRemoveCalendarEventsFromEventsCacheMatchingFilter,
    internalRemoveCalendarEventWithInstanceKeyFromEventsCache,
    removeAllFullCalendarEventsInfoForCache,
    internalDeleteEventsCache,
    removeFullCalendarEventInfo,
} from '../actions/eventsCacheActions';
import {
    cacheReloaded,
    calendarEventsAdded,
    calendarEventsRemoved,
    deleteEventsCache,
} from '../actions/publicActions';

orchestrator(cacheReloaded, actionMessage => {
    const { previousEvents, reloadedEvents } = actionMessage;
    if (reloadedEvents) {
        if (previousEvents) {
            // When cache reloads trigger an event with
            // what events were removed (which were previously in cache)
            calendarEventsRemoved(previousEvents);
        }

        // Trigger an event which indicates which events got added
        // due to cache being reloaded
        calendarEventsAdded(reloadedEvents);
    }
});

orchestrator(removeCalendarEventsFromEventsCacheMatchingFilter, actionMessage => {
    const { folderId, predicate } = actionMessage;

    let eventsRemoved: CalendarEventEntity[] = null;
    internalRemoveCalendarEventsFromEventsCacheMatchingFilter(folderId, predicate, er => {
        eventsRemoved = er;
    });

    if (eventsRemoved) {
        // For the events being removed trigger a corresponding remove of full item info
        // and trigger the action indicating events that got removed
        eventsRemoved.forEach(event => removeFullCalendarEventInfo(folderId, event.Key));
        calendarEventsRemoved(eventsRemoved);
    }
});

orchestrator(removeCalendarEventWithInstanceKeyFromEventsCache, actionMessage => {
    const { folderId, instanceKey } = actionMessage;

    let eventsRemoved: CalendarEventEntity[] = null;
    internalRemoveCalendarEventWithInstanceKeyFromEventsCache(folderId, instanceKey, er => {
        eventsRemoved = er;
    });

    if (eventsRemoved) {
        // For the events being removed trigger a corresponding remove of full item info
        // and trigger the action indicating events that got removed
        eventsRemoved.forEach(event => removeFullCalendarEventInfo(folderId, event.Key));
        calendarEventsRemoved(eventsRemoved);
    }
});

orchestrator(addCalendarEventsWithinCurrentLockedDateRanges, actionMessage => {
    const { folderId, calendarEvents } = actionMessage;

    const lockedDateRanges = getAllLockedDateRanges(folderId);
    const { eventsOverlapping } = getCalendarEventsOverlappingDateRanges(
        calendarEvents,
        lockedDateRanges
    );

    if (eventsOverlapping.length > 0) {
        // If there are events that overlap with the current locked date ranges
        // then add those to cache, ignore the rest
        upsertCalendarEventsToEventsCache(folderId, eventsOverlapping);
        calendarEventsAdded(eventsOverlapping);
    }
});

orchestrator(calendarEventsInEventsCacheReloaded, actionMessage => {
    const { folderId, eventsReloaded, forceReload } = actionMessage;

    const originalItems = getAllCalendarEvents(folderId);

    upsertCalendarEventsToEventsCache(folderId, eventsReloaded, forceReload);

    cacheReloaded(originalItems, eventsReloaded);
});

orchestrator(deleteEventsCache, actionMessage => {
    const { folderId } = actionMessage;
    removeAllFullCalendarEventsInfoForCache(folderId);
    internalDeleteEventsCache(folderId);
});
